import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import MobileNav from './MobileNav'
import TutorialTour from './onboarding/TutorialTour'
import AtLakeAutoPrompt from './AtLakeAutoPrompt'

const Layout = () => {
  // Re-key the main region on navigation so the calm page-rise entrance
  // replays each time a member moves between pages. `animate-rise` is a
  // no-op under prefers-reduced-motion (see index.css).
  const { pathname } = useLocation()
  return (
    <div className="min-h-screen flex flex-col bg-paper paper-bg">
      <Header />
      {/* pb-24 lg:pb-0 leaves room above the bottom-tab bar on mobile.       */}
      <main
        key={pathname}
        className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 pb-24 lg:pb-12 animate-rise"
      >
        <Outlet />
      </main>
      <Footer />
      <MobileNav />
      <TutorialTour />
      {/* One-time auto-detect opt-in + background at-the-lake check. */}
      <AtLakeAutoPrompt />
    </div>
  )
}

export default Layout
